<template>

  <section>
    <input type="hidden" name="tpa_fee_form" :value="selection">
    <div class="row">
      <div class="col-md-12">
        <div class="row mt-3">
          <div class="col-md-12">

            <div class="form-group row"><label class="offset-sm-1 col-sm-2 col-form-label">Fee Schedule:</label>
              <div class="col-sm-6">
                <fee-schedule :schedules="schedules" v-model = "feeSchedule"></fee-schedule>
              </div>
            </div>
          </div>


        </div>

        <div class="row mt-3">
          <div class="col-md-12">

            <div class="form-group row"><label class="offset-sm-1 col-sm-2 col-form-label">Date:</label>
              <div class="col-sm-6">
                <datepicker :max-date="(new Date()).toISOString()" v-model="date"></datepicker>
              </div>
            </div>
          </div>


        </div>

        <div class="row mt-4">
          <div class="col-md-12">
            <h3>Fees</h3>
            <table class="table table-bordered table-hover v-middle" id="invoice_fees">
              <thead>
                <tr>
                  <th class="text-center w-50s"></th>
                  <th class="w-300">Fee Name</th>
                  <th class="text-center w-150s">Fee</th>
                  <th class="text-center w-150s">Quantity</th>
                  <th class="text-center w-150s">Surcharge</th>
                  <th class="text-center w-150s">Total</th>
                </tr>
              </thead>
              <tbody>

                <!-- FeeSchedule Fees -->
                <tr v-for="fee in feeSchedule.fees" :key="fee.id" :class="{ 'bg-light-success': fee.selected }">
                  <td class="text-center">
                    <div class="checkbox m-b-none m-t-sm">
                      <label><input type="checkbox" v-model="fee.selected" ></label>
                    </div>
                  </td>
                  <td>
                    <p class="form-control-plaintext"><strong>{{ fee.name }}</strong></p>
                  </td>
                  <td class="text-center">
                    <p class="form-control-plaintext">{{ formatFee(fee) }}</p>
                  </td>
                  <td class="text-center fee-quantity">
                    <input type="number" class="form-control"  v-if="fee.per_unit" v-model="fee.quantity">
                    <p class="form-control-plaintext" v-else>-</p></td>
                  <td class="text-center">
                    <p class="form-control-plaintext" v-if="fee.id !== 'cat_surcharge'">{{ usd(feeSurcharge(fee)) }}</p>
                    <p class="form-control-plaintext" v-else>-</p>
                  </td>
                  <td class="text-center">
                    <p class="form-control-plaintext fee-total" v-if="fee.selected && fee.id !== 'cat_surcharge'">{{ usd(totalFee(fee)) }}</p>
                  </td>
                </tr>

                <!-- Custom Fees -->
                <tr v-for="(fee, index) in customFees" :key="fee.id" :class="{ 'bg-light-success': fee.selected }">
                  <td class="text-center">
                    <button class="btn btn-xs btn-outline-danger" @click.prevent="removeCustomFee(fee.id)"><i class="fa fa-fw fa-remove"></i></button>
                  </td>
                  <td>
                    <input type="text" v-model="customFees[index].name" class="form-control form-control-sm" placeholder="Enter fee name and value to enable it in the list.">
                  </td>
                  <td class="text-center">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-addon">$</span>
                      </div>
                      <input type="number" step="0.01" v-model="customFees[index].fee" class="form-control form-control-sm">
                    </div>
                  </td>
                  <td class="text-center fee-quantity">
                    -
                  </td>
                  <td class="text-center">
                    $0.00
                  </td>
                  <td class="text-center">
                    <p class="form-control-plaintext fee-total" v-if="fee.selected">{{ usd(totalFee(fee)) }}</p>
                  </td>
                </tr>

              </tbody>
              <tfoot>
              <tr class="active">
                <td class="text-right"></td>
                <td><button class="btn btn-xs btn-outline-success" @click.prevent="addCustomFee"><i class="fa fa-fw fa-plus-circle"></i> Custom Fee</button></td>
                <td></td>
                <td class="text-center"></td>
                <td class="text-center"></td>
                <td class="text-center font-weight-bold">
                  {{ usd(totalTpaFee) }}
                </td>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>


</template>

<script>

import TpaFeeScheduleSelector from './TpaFeeScheduleSelector.vue';
import Datepicker from "../Datepicker.vue";

export default {
  name: "TpaFee",
  components: {
    "fee-schedule": TpaFeeScheduleSelector,
    "datepicker": Datepicker,
  },
  props: {
    schedules: {
      type: Array,
      required: true
    },
    custom: {
      type: Array,
      default: () => {return []}
    },
    defaultFeeSchedule: {
      type: Number,
      required: true
    },
    createdAt: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      feeSchedule: this.schedules.filter(schedule => schedule.id === this.defaultFeeSchedule).pop(),
      customFees: this.custom,
      date: new Date(this.createdAt * 1000)
    }
  },
  methods: {

    feeSurcharge(fee) {
      if (fee.id !== 'cat_surcharge') return fee.fee * this.surchargeRate / 100;

      return 0;
    },

    totalFee(fee) {
      if (fee.id !== 'cat_surcharge')
      {
        let quantity = fee.id === 'building_charge' ? 0 : 1;
        if (fee.quantity > 0) {
          quantity = fee.quantity;
        }
        return quantity * (fee.fee + this.feeSurcharge(fee));
      }

      return 0;
    },

    formatFee(fee) {
      if (fee.id === 'cat_surcharge') return this.pct(fee.fee/100.0);

      return this.usd(fee.fee);
    },

    addCustomFee() {
      this.customFees.push({
        'id': 'custom_' + (this.customFees.length + 1),
        'name': '',
        'fee': 0,
        'selected': false,
      });
    },

    removeCustomFee(idToRemove) {
      this.customFees = this.customFees.filter(fee => String(fee.id) !== idToRemove);
    },

  },
  computed: {
    totalTpaFee() {
      const fees = this.feeSchedule.fees.concat(this.customFees);
      return fees.filter(fee => {
          return !!fee.selected && fee.id !== 'cat_surcharge';
        })
        .reduce((total, fee) => {
          return total + this.totalFee(fee);
        }, 0);
    },

    surchargeRate() {
      if (this.feeSchedule.fees.length) {
        let result = this.feeSchedule.fees.filter(fee => fee.selected && fee.id === 'cat_surcharge');

        if (result.length) {
          return result[0].fee;
        }
      }

      return 0;
    },

    selection() {

      return JSON.stringify({
        schedule: this.feeSchedule,
        custom: this.customFees,
        total: this.totalTpaFee,
        date: this.date
      });
    }
  },

  watch: {
    customFees: {
      handler(val) {
        val.forEach(fee => {
          fee.selected = !!fee.fee && fee.name;
        });
      },
      deep: true
    },
  },
}
</script>

<style scoped>

</style>
